// Use a function to initialize modal logic, and call it on DOMContentLoaded and after AJAX loads
function initExplainatoryPopups() {
  // Remove previous event listeners by cloning nodes (to avoid duplicate listeners)
  document.querySelectorAll("button[data-popup-id]").forEach((button) => {
    const newButton = button.cloneNode(true);
    if (button.parentNode) button.parentNode.replaceChild(newButton, button);
  });
  document.querySelectorAll(".popup-overlay").forEach((overlay) => {
    const newOverlay = overlay.cloneNode(true);
    if (overlay.parentNode) overlay.parentNode.replaceChild(newOverlay, overlay);
  });
  document.querySelectorAll(".popup").forEach((popup) => {
    const newPopup = popup.cloneNode(true);
    if (popup.parentNode) popup.parentNode.replaceChild(newPopup, popup);
  });

  // Attach event delegation to the document
  document.addEventListener("click", function(event) {
    // Open modal
    const btn = event.target.closest("button[data-popup-id]");
    if (btn) {
      const popupId = btn.getAttribute("data-popup-id");
      const myPopup = document.getElementById(`myPopup${popupId}`);
      const popupOverlay = document.getElementById(`popupOverlay${popupId}`);
      if (myPopup && popupOverlay) {
        openPopup(myPopup, popupOverlay);
        event.stopPropagation();
      }
      return;
    }
    // Close modal by close button
    if (event.target.classList.contains("close-btn")) {
      const popup = event.target.closest(".popup");
      if (popup) {
        const popupId = popup.id.replace("myPopup", "");
        const overlay = document.getElementById(`popupOverlay${popupId}`);
        closePopup(popup, overlay);
      }
      return;
    }
    // Close modal by overlay
    if (event.target.classList.contains("popup-overlay")) {
      const popupId = event.target.id.replace("popupOverlay", "");
      const popup = document.getElementById(`myPopup${popupId}`);
      closePopup(popup, event.target);
      return;
    }
  });
}

function openPopup(myPopup, popupOverlay) {
  myPopup.classList.add("active");
  popupOverlay.classList.add("active");
  document.body.classList.add("no-scroll");
  // Adjust z-index of other elements
  const elementsToAdjust = [
    { selector: ".section-header", zIndex: "0" },
    { selector: ".announcement-bar", zIndex: "0" },
    { selector: ".utility-bar__right", zIndex: "-1" },
    { selector: ".filters-adjacent", zIndex: "-1" },
    { selector: ".page-header", zIndex: "-1" }
  ];
  elementsToAdjust.forEach(({ selector, zIndex }) => {
    const element = document.querySelector(selector);
    if (element) {
      element.style.zIndex = zIndex;
    }
  });
}

function closePopup(myPopup, popupOverlay) {
  if (!myPopup || !popupOverlay) return;
  myPopup.classList.remove("active");
  popupOverlay.classList.remove("active");
  document.body.classList.remove("no-scroll");
  // Restore z-index of other elements
  const elementsToRestore = [
    { selector: ".section-header", zIndex: "400" },
    { selector: ".announcement-bar", zIndex: "401" },
    { selector: ".utility-bar__right", zIndex: "1" },
    { selector: ".filters-adjacent", zIndex: "1" },
    { selector: ".page-header", zIndex: "1" }
  ];
  elementsToRestore.forEach(({ selector, zIndex }) => {
    const element = document.querySelector(selector);
    if (element) {
      element.style.zIndex = zIndex;
    }
  });
}

// Initialize on DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initExplainatoryPopups);
} else {
  initExplainatoryPopups();
}

// Re-initialize after Shopify section or AJAX loads
// Listen for Shopify's section:load event and custom events
["shopify:section:load", "ajaxComplete", "ajaxSuccess", "ajaxRun"].forEach((evtName) => {
  document.addEventListener(evtName, initExplainatoryPopups);
});
